import { ChangeDetectionStrategy, Component, ElementRef, inject, signal } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { ActivitySectionDirective, UserActivityClickTrackingDirective } from '@core';
import { PartyComponent } from '@app/pages/main-page/more/party/party.component';
import { ReviewComponent } from '@app/pages/main-page/more/review/review.component';
import { GiftCardsComponent } from '@app/pages/main-page/more/gift-cards/gift-cards.component';
import { ScheduleComponent } from '@app/pages/main-page/more/schedule/schedule.component';
import { ApparelComponent } from '@app/pages/main-page/more/apparel/apparel.component';

type State = 'main' | 'schedule' | 'gift-cards' | 'party' | 'review' | 'apparel';

@Component({
  selector: 'app-page-more',
  styleUrl: './more.component.scss',
  templateUrl: './more.component.html',
  imports: [
    PageHeaderComponent,
    ActivitySectionDirective,
    UserActivityClickTrackingDirective,
    ScheduleComponent,
    PartyComponent,
    ReviewComponent,
    GiftCardsComponent,
    ApparelComponent,
  ],
  host: {
    'class': 'page',
  },
  animations: [
    trigger('InOutAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('400ms ease-in-out', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [
        animate('400ms ease-in-out', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    direction: 'vertical',
    element: this.elementRef.nativeElement,
  };

  public readonly state = signal<State>('main');

}
